import { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/timetable/TimeTableAction";
import { 
  allTimetableDeletionAlert,
  getAuthorities,
  redirectToPages,
  resultAlert,
  emptyTermOrSemesterAlert,
  noFileAlert,
  exportAllTimetableToExcel,
  TimetableType,
  exportASCDataToXml,
  nonXmlFormatAlert,
  missingDataAlert,
  getAllDayAndHourData,
  ExportButton,
  exportAllTimetableToPDF,
  DeleteButton,
  FormButton,
  printAllTimetable,
  InfoButton,
  copyAllTimetable
} from "../../../../../_helpers/Helpers";
import { useSubheader } from "../../../../../_metronic/layout";
import KTWizard from "../../../../../_metronic/_assets/js/components/wizard";
import { 
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar
} from "../../../../../_metronic/_partials/controls";
import { TransferFromASC } from "./TransferFromASC";
import { TimetableTransfer } from "./TimetableTransfer";
import { TimeTableWizardNav } from "./TimeTableWizardNav";
import { Timetable } from "./TimeTable";

export function TimeTablePage({ 
  history
}) {
  // Subheader
  const subheader = useSubheader();
  const [title, setTitle] = useState("");
  const [term, setTerm] = useState(0);
  const [term2, setTerm2] = useState(1);
  const [semester, setSemester] = useState(0);
  const [showASCDialog, setShowASCDialog] = useState(false);
  const [showTransferDialog, setShowTransferDialog] = useState(false);
  const openASCDialog = () => setShowASCDialog(true);
  const openTransferDialog = () => setShowTransferDialog(true);
  const closeDialog = () => { 
    setShowASCDialog(false);
    setShowTransferDialog(false);
  }
  const dispatch = useDispatch();
  const { 
    actionsLoading,
    isSuccess,
    type,
    authorities,
    currentActiveTerm,
    currentActiveSemester,
    sections,
    teachers,
    courseHours, 
    timetable
  } = useSelector(
    (state) => ({
      actionsLoading: state.timetable.actionsLoading,
      isSuccess: state.timetable.isSuccess,
      type: state.timetable.type,
      authorities: state.timetable.authorities,
      currentActiveTerm: state.auth.user.currentActiveTerm,
      currentActiveSemester: state.auth.user.currentActiveSemester,
      sections: state.timetable.sections,
      teachers: state.timetable.teachers,
      courseHours: state.timetable.courseHours,
      timetable: state.timetable.timetable
    }),
    shallowEqual
  );
  
  // Authority Parameters
  const { isEditionAuthorized, isDeletionAuthorized, isExportationAuthorized } = getAuthorities(authorities);

  useEffect(() => {
    setTerm(currentActiveTerm);
    setTerm2(currentActiveTerm + 1);
    setSemester(currentActiveSemester);
    dispatch(actions.getCurrentTimetable());
    return () => dispatch(actions.cleanTimetableState());
  }, [currentActiveTerm, currentActiveSemester, dispatch]);

  useEffect(() => {
    let _title = "Ders Programı";
    setTitle(_title);
    subheader.setTitle(_title);
  }, [subheader]);
  
  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  /** ASC Programına Aktarım Verisini Hazırlar */
  const prepareASCData = () => {
    dispatch(actions.getCoursesAndTeachers()).then((result) => {
      if (result.isSuccess) {
        const { courses, teachers } = result.entity;
        exportASCDataToXml({ courses, sections, teachers });
      
      } else {
        onResult(result);
      }      
    });    
  }

  /** Belli Bir ASC Ders Programı Dosyasını Yükleyerek Belli Bir Yıl ve Dönemdeki Ders Programını Sisteme Aktarır */
  const uploadASCFile = (file) => {
    if (!term || !semester) {
      emptyTermOrSemesterAlert();
      return;
    }
    if (!file) {
      noFileAlert();
      return;
    }
    if (file.type !== "text/xml" && file.type !== "application/xml") {
      nonXmlFormatAlert();
      return;
    }
    const reader = new FileReader();
    reader.onload = async function(e) {
      const dayAndHourData = getAllDayAndHourData(e);

      if (!dayAndHourData) {
        missingDataAlert();
        return;
      }
      const values = {
        term: term,
        semester: semester,
        dayAndHourData: dayAndHourData
      };
      dispatch(actions.saveAllTimetable(values)).then((result) => onResult(result));
    }
    reader.readAsText(file);
  }

  /** Belli Bir Dönemdeki Tüm Ders Programını Başka Bir Döneme Aktarır */
  const transferTimetable = (values) => {
    if (!values.sourceTerm || !values.sourceSemester || !values.destinationTerm || !values.destinationSemester) {
      emptyTermOrSemesterAlert();
      return;
    }
    dispatch(actions.transferTimetable(values)).then((result) => onResult(result));
  };

  /** Belli Bir Yıl ve Dönemdeki Tüm Ders Programını Siler */
  const deleteTimetable = () => {
    if (!term || !semester) {
      emptyTermOrSemesterAlert();
      return;
    }
    allTimetableDeletionAlert().then(result => {
      if (result.isConfirmed) {
        const values = {
          term: term,
          semester: semester
        };
        dispatch(actions.deleteTimetable(values)).then((result) => onResult(result));
      }
    });
  };

  /** Belli Bir Yıl ve Dönemdeki Tüm Sınıf veya Öğretmen Ders Programını Excele Aktarır */
  const exportToExcel = (type) => {
    const headers = type === TimetableType.Section ? sections : type === TimetableType.Teacher ? teachers : [];
    const header = type === TimetableType.Section ? "Sınıf" : type === TimetableType.Teacher ? "Öğretmen" : "";
    const filename = term + " - " + (term + 1) + " Eğitim Öğretim Yılı " + semester + ". Dönem " + header + " Ders Programı";
    const sheetname = header + " Ders Programı";
    exportAllTimetableToExcel({ type, headers, courseHours, timetable, filename, sheetname });
  }

  /** Belli Bir Yıl ve Dönemdeki Tüm Sınıf veya Öğretmen Ders Programını PDF e Aktarır */
  const exportToPDF = (type) => {  
    const headers = type === TimetableType.Section ? sections : type === TimetableType.Teacher ? teachers : [];
    const header = type === TimetableType.Section ? "Sınıf" : type === TimetableType.Teacher ? "Öğretmen" : "";
    const filename = term + " - " + (term + 1) + " Eğitim Öğretim Yılı " + semester + ". Dönem " + header + " Ders Programı";
    exportAllTimetableToPDF({ dispatch, type, headers, courseHours, timetable, filename });
  }

  /** Belli Bir Yıl ve Dönemdeki Tüm Sınıf veya Öğretmen Ders Programını Yazdırma Penceresini Açar */
  const print = (type) => {
    const headers = type === TimetableType.Section ? sections : type === TimetableType.Teacher ? teachers : [];
    printAllTimetable({ type, term, semester, headers, courseHours, timetable });
  }

  /** Belli Bir Yıl ve Dönemdeki Tüm Sınıf veya Öğretmen Ders Programını Panoya Kopyalar */
  const copy = (type) => {
    const headers = type === TimetableType.Section ? sections : type === TimetableType.Teacher ? teachers : [];
    copyAllTimetable({ type, term, semester, headers, courseHours, timetable });
  }

  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);    
    if (isSuccess) setTimeout(() => {
      closeDialog();
      dispatch(actions.getAllTimetable(term, semester));
    }, 2500);
  };

  // Timetable Wizard
  const options = {
    startStep: 1,
    clickableSteps: true
  };

  new KTWizard(document.querySelector("#timetable_wizard"), options);

  return (
    <>
      <TransferFromASC
        prepareASCData={prepareASCData}
        uploadASCFile={uploadASCFile}
        showASCDialog={showASCDialog}
        closeDialog={closeDialog}
      />
      
      <TimetableTransfer
        currentTerm={term}
        currentSemester={semester}
        transferTimetable={transferTimetable}
        showTransferDialog={showTransferDialog}
        closeDialog={closeDialog}
      />

      <Card>
        {actionsLoading && <ModalProgressBar />}
        <CardHeader title={title}>
          {
            (isEditionAuthorized || isDeletionAuthorized || isExportationAuthorized) &&
            <CardHeaderToolbar>
              {
                isEditionAuthorized &&
                <>
                  <InfoButton
                    path="Files/Import"
                    title="ASC Programından Aktar"
                    method={openASCDialog}
                  />
                  <FormButton
                    path="Navigation/Exchange"
                    title="Ders Programını Sonraki Döneme Aktar"
                    method={openTransferDialog}
                  />
                </>
              }
              {
                isDeletionAuthorized &&
                <DeleteButton
                  title="Tüm Ders Programını Sil"
                  method={deleteTimetable}
                />
              }
            </CardHeaderToolbar>
          }
        </CardHeader>
        <CardBody>
          <div className="form-group row">
            <label className="col-3 mt-3">
              Yıl
            </label>
            <div className="col-2">
              <input
                type="number"
                className="form-control"
                min={1}
                value={term}
                placeholder="Yıl"
                onChange={e => {
                  if (e.target.value && semester) dispatch(actions.getAllTimetable(e.target.value, semester));
                  const value2 = e.target.value !== "" ? parseInt(e.target.value) + 1 : "";
                  setTerm(e.target.value);
                  setTerm2(value2);
                }}
              />
            </div>
            <div className="col-2">
              <input className="form-control" value={term2} readOnly />
            </div>
          </div>

          <div className="form-group row">
            <div className="col-3 mt-3">
              Dönem
            </div>
            <div className="col-2">
              <input
                type="number"
                className="form-control"
                min={1}
                max={4}
                value={semester}
                placeholder="Dönem"
                onChange={e => {
                  if (term && e.target.value) dispatch(actions.getAllTimetable(term, e.target.value));
                  setSemester(e.target.value);
                }}
              />
            </div>
          </div>        
          <div className="mb-10"></div>

          {/* <!--begin: Wizard --> */}
          <div
            className="wizard wizard-4"
            id="timetable_wizard"
            data-wizard-state="step-first"
          >
            {/* <!--begin: Form Wizard Nav --> */}
            <TimeTableWizardNav />
            {/* <!--end: Form Wizard Nav --> */}

            <div className="pt-lg-5">
              {/* <!--begin: Form Wizard Form--> */}
              {/* <!--begin: Form Wizard Step 1--> */}
              <div data-wizard-type="step-content" data-wizard-state="current">
                {
                  (isEditionAuthorized || isExportationAuthorized) &&
                  <div className="d-flex justify-content-end mb-5">                  
                    {
                      isExportationAuthorized &&
                      <ExportButton
                        exportToExcel={() => exportToExcel(TimetableType.Section)}
                        exportToPDF={() => exportToPDF(TimetableType.Section)}
                        print={() => print(TimetableType.Section)}
                        copy={() => copy(TimetableType.Section)}
                      />
                    }
                    {
                      isEditionAuthorized &&
                      <FormButton
                        path="Communication/Write"
                        title="Düzenle"
                        method={() => history.push("/ders-programi/sinif-duzenle")}
                      />
                    }                    
                  </div>
                }
                <Timetable
                  tableType="section"
                  headers={sections}
                  courseHours={courseHours}
                  timetable={timetable}
                />
              </div>
              {/* <!--end: Form Wizard Step 1--> */}

              {/* <!--begin: Form Wizard Step 2--> */}
              <div data-wizard-type="step-content">
                {
                  (isEditionAuthorized || isExportationAuthorized) &&
                  <div className="d-flex justify-content-end mb-5">
                    {
                      isExportationAuthorized &&
                      <ExportButton
                        exportToExcel={() => exportToExcel(TimetableType.Teacher)}
                        exportToPDF={() => exportToPDF(TimetableType.Teacher)}
                        print={() => print(TimetableType.Teacher)}
                        copy={() => copy(TimetableType.Teacher)}
                      />
                    }          
                    {
                      isEditionAuthorized &&
                      <FormButton
                        path="Communication/Write"
                        title="Düzenle"
                        method={() => history.push("/ders-programi/ogretmen-duzenle")}
                      />
                    }      
                  </div>
                }
                <Timetable
                  tableType="teacher"
                  headers={teachers}
                  courseHours={courseHours}
                  timetable={timetable}
                />
              </div>
              {/* <!--end: Form Wizard Step 2--> */}
              {/* <!--end: Form Wizard Form--> */}
            </div>
          </div>
          {/* <!--end: Wizard --> */}
        </CardBody>
      </Card>
    </>    
  );
}